module.exports = __webpack_public_path__ + "img/Indonesia-01.e1885f5d.jpg";